import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import spread from "../../images/svg/spread.svg";
import { getAracItemData, getUyeItemData } from "../../features/uyelerAraclar/uyelerAraclarSlice";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { setSelectedUser } from "../../features/companyProfile/companyAuthorizationSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .detay {
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
      }
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
        }
      }
    }
  }
`;

const ProfilimKullanicilarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  
  return (
    <Container theme={theme} onClick={() => dispatch}>
      <div className="container">
        <div className="content">
          <div onClick={(e) => {e.stopPropagation(); dispatch(showModal("profilAltKullaniciOptions")); dispatch(setSelectedUser(data))}} className="detay" >
            <img src={spread} alt="" />
          </div>
          <div className="row">
            <div className="col">{data?.userName}</div>
            <div className="col">{data?.email}</div>
            <div className="col">{data?.phoneNumber}</div>
            <div className="col">Alt Üye</div>
            <div className="col">{data?.isActive ? "Pasif" : "Aktif"}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProfilimKullanicilarContainer;
